import styled from "@emotion/styled";
import React from "react";
import { AppBottomSheet } from "./Generic/AppBottomSheet";
import { AppButton } from "./Generic/AppButton";

interface Props {
  isOpen: boolean;
  title: string;
  items: Item[];
  onClose: () => void;
}

interface Item {
  title: string;
  leading?: React.ReactNode;
  onClick: () => void;
}

const BottomSheetMenu: React.FC<Props> = ({ isOpen, title, items, onClose }) => {
  return (
    <AppBottomSheet
      isOpen={isOpen}
      rounded={true}
      title={title}
      onRequestClose={onClose}
      restrictHeight={false}
    >
      <List>
        {items.map((item, index) => (
          <Item key={index} variant="outline" block onClick={item.onClick}>
            <Leading>{item.leading}</Leading>
            <Title>{item.title}</Title>
          </Item>
        ))}
      </List>
      <Spacer />
    </AppBottomSheet>
  );
};

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Item = styled(AppButton)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

const Spacer = styled.div`
  height: 16px;
`;

const Title = styled.div``;

const Leading = styled.div`
  flex-shrink: 0;
`;

export default BottomSheetMenu;
